<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/menumanage/add"
      selectShowPower="/moneyList/select"
      buttonName="提现"
       :batchShow="true"
      batchpass="/withdrawalreview/batch"
      batchName="批量同意"
       batchShowType="warning"
        @batchLookDialog="openNewAgree(1, dialogModel.applyIdStr, 8888)"
    >
      <el-form-item
        label="机构名称"
        prop="activityName"
        v-if="this.textTatSimpleId"
        filterable
      >
        <el-select style="width: 198px" v-model="formModel.tatSimpleId">
          <el-option
            v-for="item in typeTwo"
            :key="item"
            :label="item.tatName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作时间" v-if="this.textTatSimpleId">
        <el-date-picker
          v-model="formModel.activeTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage" @handleSelectionChange="handleSelectionChange">
       <el-table-column
        type="selection"
        :selectable="checkboxT"
        disabled="true"
        width="60"
        margin-left="5px"
      >
      </el-table-column>
      <el-table-column
        prop="tatSimpleName"
        label="机构名称"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
           <el-table-column
        prop="withdrawType"
        label="可转账类型"
        min-width="120"
        :formatter="formatterTableDataAge"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p v-if="scope.row.withdrawType == 2">线下转账</p>
          <p v-if="scope.row.withdrawType == 1">线上转账</p>
        
        </template></el-table-column
      >
      <el-table-column
        prop="status"
        label="状态"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p v-if="scope.row.status == 0">待审核</p>
          <p v-if="scope.row.status == 1">处理中</p>
          <p v-if="scope.row.status == 2">成功</p>
          <p v-if="scope.row.status == 3">驳回</p>
          <p v-if="scope.row.status == 4">失败</p>
        </template></el-table-column
      >
        <el-table-column
        prop="orderNo"
        label="订单号"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="姓名"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="phone"
        label="手机号"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="idCard"
        label="身份证号"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cardNo"
        label="卡号"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="amount"
        label="提现金额(元)"
        min-width="120"
        show-overflow-tooltip
      >
      <template slot-scope="scope">
          <p>{{ scope.row.amount / 100 }}</p>
        </template>
      </el-table-column>
          <el-table-column
        prop="realAmount"
        label="订单实际金额(元)"
        min-width="120"
        show-overflow-tooltip
      >
      <template slot-scope="scope">
          <p>{{ scope.row.realAmount / 100 }}</p>
        </template>
      </el-table-column>
          <el-table-column
        prop="feeAmout"
        label="手续费(元)"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.feeAmout / 100 }}</p>
        </template>
      </el-table-column>
       <el-table-column
        prop="resMsg"
        label="错误信息"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="260"
        fixed="right"
        v-if="this.textTatSimpleId"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">
            <!-- <el-button type="text" @click="handleStatus(scope.row.id, 0)"
              >通过
            </el-button> -->
            <!-- v-if="hasPerm('/apppointsshopmanage/update')" -->
            <el-button
              type="text"
              @click="handleStatus(scope.row.id, 1)"
              class="button-color"
            >
              驳回
            </el-button>
          </div>
          <div v-else-if="scope.row.status != 0">--</div>
          <!-- <el-button
            type="text"
            v-if="hasPerm('/apppointsshopmanage/del')"
            @click="handleDelete(scope.row)"
            >删除
          </el-button> -->
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="'添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="300px"
      dialogWidth="589px"
    >
      <el-form-item label="姓名" prop="userName">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.userName"
          placeholder="请输入姓名"
          style="width: 180px"
        ></el-input>
      </el-form-item>

      <el-form-item label="手机号" prop="phone">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.phone"
          placeholder="请输入手机号"
          style="width: 180px"
        ></el-input>
      </el-form-item>

      <el-form-item label="身份证" prop="idCard">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.idCard"
          placeholder="请输入身份证"
          style="width: 180px"
        ></el-input>
      </el-form-item>

      <el-form-item label="提现金额" prop="amount">
        <el-input-number
          :controls="false"
          placeholder="请输入提现金额"
          v-model="dialogModel.amount"
          text-align="auto"
          :precision="2"
          :step="0"
          :min="20"
          :max="10000"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="卡号" prop="cardNo">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.cardNo"
          placeholder="请输入卡号"
          style="width: 180px"
        ></el-input>
      </el-form-item>
    </form-dialog>
    <form-dialog
      ref="formDialogNew"
      formDialogTitle="同意"
      :dialogService="dialogServiceNew"
      :model="dialogModel"
      :submitData="dialogDataNew"
      @close="dialogCloseNew"
      @success="dialogSuccessNew"
      labelWidth="110px"
      class="note"
    >
      <el-radio v-model="dialogModel.withdrawType" label="1">线上转账</el-radio>
      <el-radio v-model="dialogModel.withdrawType" label="2">线下转账</el-radio>
    </form-dialog>
  </div>
</template>

<script>
import MallService from "service/MallService";
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ImageViewer from "../../dialog/ImageViewer";

import ShopService from "service/ShopService";
import TransactionService from "service/TransactionService";

import Server from "common/conf/Server";
import SelectLevel from "components/business/SelectLevel";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import Institutionlist from "service/Ainstitution";
import activity from "service/Ainstitution";
export default {
  name: "apppointsshopmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectLevel,
    ImageViewer,
  },
  data() {
    return {
        multipleSelection: [],
      typeTwo: [{ tatName: "全部", id: "" }],
      uploadUrl: Server[process.env.NODE_ENV],
      show: false,
      formModel: {
        tatSimpleId: "",
        activeTime: "",
      },
      tableData: [],
      submitService: Institutionlist.moneyWithList,
      page: {},
      isPage: false,
      itemId: "",
      dialogModel: {
         withdrawType: "1",
        tatName: "",
        connPerson: "",
        connTel: "",
        fee1: "",
        fee2: "",
         applyIdStr: [],
        // goodName: "",
      },
      payTypeScope: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      dialogRules: {
        amount: [
          {
            required: true,
            message: "请输入",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入",
          },
        ],
        cardNo: [
          {
            required: true,
            message: "请输入",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入",
          },
        ],
        userName: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      typeList: [
        {
          dictKey: "1",
          dictValue: "每月推荐",
        },
        {
          dictKey: "2",
          dictValue: "积分精品",
        },
        {
          dictKey: "3",
          dictValue: "优惠券",
        },
      ],
      typeTwoList: [],
      isFlag: false,
      checkAll: false,
      checkedCities: [],
      couponList: [],
      loading: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.needCheck();
    this.getTypeNames("merchantPayType", (res) => {
      this.payTypeScope = [...this.payTypeScope, ...res];
    });
    this.getTypeNames("积分精品商城", (res) => {
      this.typeTwoList = res;
    });
    // this.
    // this.formModel.tatSimpleId = "默认机构ID";
     this.getList()
  },
  computed: {
    submitData() {
      console.log(this.formModel, "this.form");
      if (
        this.formModel.activeTime == null ||
        this.formModel.activeTime == ""
      ) {
        this.formModel.activeTime = [];
      }
      this.params = {
        tatSimpleId: this.formModel.tatSimpleId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };  
      if (this.formModel.activeTime.length) {
        this.params.beginDate = this.formModel.activeTime[0];
        this.params.endDate = this.formModel.activeTime[1];
      }
      return this.params;
    },
    dialogData() {
      const params = {
        amount: this.dialogModel.amount * 100,
        phone: this.dialogModel.phone,
        cardNo: this.dialogModel.cardNo,
        idCard: this.dialogModel.idCard,
        userName: this.dialogModel.userName,
        tatSimpleId: this.tatSimpleId,
         applyIdStr: this.dialogModel.applyIdStr,
      };

      return params;
    },
       dialogDataNew() {
      const params = {
        withdrawType: this.dialogModel.withdrawType,
        applyIdStr: this.dialogModel.applyIdStr,

      };

      return params;
    },
    dialogService() {
      return Institutionlist.moneyWithAdd;
    },
    dialogServiceNew() {
      return MallService.withdrawalreviewListNew
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters([
      "serverType",
      "tatId",
      "userId",
      "tatSimpleId",
      "textTatSimpleId",
    ]),
  },
  watch: {},
  methods: {
     checkboxT(row, index) {
      if (row.status == 0) {
        return true;
      } else {
        return false;
      }
    },
     handleSelectionChange(val) {
      this.multipleSelection = val;

      let str = "";
      this.multipleSelection.forEach(function (item, index) {
        str += item.id + ",";
      });
      console.log(str);
      str = str.substring(0, str.length - 1);
      this.dialogModel.applyIdStr = str.split(",");
    },
    openNewAgree(flag, item, biaoji) {
       this.dialogModel.applyIdStr = item;
       this.$refs.formDialogNew.open();
    },
    load() {
      this.formModel = {
        tatSimpleId: "",
        activeTime: "",
      };
      this.page = this.$refs.commonTable.page;

      this.getList();

      this.getMoneyDetail();
      this.getTypeTwo();
    },
    getMoneyDetail() {
      this.doLoad(
        Institutionlist.moneyDetail,
        {
          id: this.tatSimpleId,
        },
        (res) => {
          this.dialogModel.userName = res.contents.userName;
          this.dialogModel.idCard = res.contents.idCard;
          this.dialogModel.phone = res.contents.phone;
          this.dialogModel.cardNo = res.contents.cardNo;
          console.log(res, "resres");
        },
        "信息获取失败"
      );
    },
    getTypeTwo() {
      this.doLoad(
        activity.signList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            // console.log(res.contents.rows, "res1");
            res.contents.rows.forEach((item) => {
              (item.dictValue = item.id), (item.dictKey = item.tatName);
            });
            this.typeTwo = [...this.typeTwo, ...res.contents.rows];
            console.log(this.typeTwo, "this.typeTwo");

            // this.tableDataNew = this.tableData
          });
          this.tableData.forEach((item) => {
            this.typeTwo.forEach((itemTwo) => {
              console.log(this.typeTwo, "type");

              if (item.tatSimpleId == itemTwo.dictValue) {
                item.tatSimpleName = itemTwo.tatName;
              } else if (!item.tatSimpleId) {
                item.tatSimpleName = "--";
              }
            });
          });
        },
        "信息获取失败"
      );
    },
    // 启用禁用
    handleStatus(id, status) {
      this.showConfirm(`确定${status == 0 ? "通过" : "驳回"}？`)
        .then(() => {
          this.doStatus(id, status);
        })
        .catch(() => {});
    },
    doStatus(id, status) {
      this.doLoad(
        status == 0 ? Institutionlist.moneyAgree : Institutionlist.moneyUnAgree,

        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.contents.optMsg);
            this.getList();
          });
        },
        "信息获取失败"
      );
    },

    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
          
          // this.getTypeTwo()
        },
         
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        ShopService.apppointsshopmanageDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },

    openAddDialog(item, flag) {
      console.log(item, "item");
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.couponGroupId = Number(this.dialogModel.couponGroupId);
        if (!this.dialogModel.otherImgsUrl) {
          this.dialogModel.otherImgsUrl = [];
        } else {
          this.dialogModel.otherImgsUrl =
            this.dialogModel.otherImgsUrl.split(",");
        }
      }
      this.$refs.formDialog.open();
    },
    dialogClose() {
      // this.dialogModel = {
      //   tatName: "",
      //   connPerson: "",
      //   connTel: "",
      //   fee1: "",
      //   fee2: "",
      // };
      // this.itemId = "";
    },
    dialogCloseNew() {
      this.$refs.formDialogNew.closeDialog()
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    dialogSuccessNew(res) {
        this.showSuccess(res.respMsg);
      this.$refs.formDialogNew.closeDialog();
      this.getList();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;

        this.tableData.forEach((item) => {
          this.typeTwo.forEach((itemTwo) => {
            if (item.tatSimpleId == itemTwo.dictValue) {
              item.tatSimpleName = itemTwo.dictKey;
            } else if (!item.tatSimpleId) {
              item.tatSimpleName = "--";
            }
          });
        });
      });
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.imgUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    beforeAvatarUploadOther(file) {
      this.loading = true;
      console.log(file);
      const isVideo = file.type === "video/mp4";

      const isLt2M = file.size / 1024 / 1024 < 12;
      console.log(isVideo && !isLt2M, isVideo, !isLt2M);
      if (isVideo && !isLt2M) {
        this.loading = false;
        this.$message.error("上传视频大小不能超过 12MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    otherError() {
      this.loading = false;
    },
    formatterTableDataTypeTwo(row, column, cellValue, index) {
      let value = "--";
      if (row.type == 3) {
        return row.couponGroupName ? row.couponGroupName : value;
      }
      if (row.type == 2) {
        return cellValue ? cellValue : value;
      }
      return value;
    },
    formatterTableDataType(row, column, cellValue, index) {
      let value = "--";
      this.typeList.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    handleAvatarSuccess1(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.otherImgsUrl.push(res.contents);
        this.loading = false;
      });
    },
    handleImgClick(url) {
      this.dialogModel.otherImgsUrl = this.dialogModel.otherImgsUrl.filter(
        (item) => item !== url
      );
    },
     formatterTableDataAge(row, column, cellValue, index) {
       console.log(cellValue,'cellValue')
      let value = "--";
      if (cellValue >= 18 && cellValue < 70) {
        value = "线上转账";
      } else {
        value = <span style="color: red;">线下转账</span>;
      }
      return value;
    },
  },
};
</script>

<style scoped>
/deep/.el-input-number .el-input__inner {
  text-align: left;
}
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}

.alliconUrl {
  /* width: 50px;
        height: 50px; */
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

/deep/ .el-upload--picture-card {
  /* background-color: #fbfdff; */
  border: 0px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 35px !important;
  height: 35px !important;
  line-height: 35px !important;
  vertical-align: top;
}

/deep/ .el-upload--picture-card i {
  font-size: 40px;
  color: #8c939d;
}

.newimg {
  display: flex;
  flex-wrap: wrap;
}

.newimg div:nth-child(2) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(5) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(8) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(11) {
  margin: 0px 10px 10px 10px;
}

.newavatar {
  width: 70px;
  height: 70px;
  display: block;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
}

.newavatar:hover {
  width: 70px;
  height: 70px;
  border: 1px dashed red;
  border-radius: 6px;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: 5px 5px 0px 5px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/InstitutionList/institutionWith.vue